import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatrixCardComponent } from '../../../../shared/components/matrix-card/matrix-card.component';

@Component({
  selector: 'app-feature-comparison-card',
  standalone: true,
  imports: [CommonModule, MatrixCardComponent],
  templateUrl: './feature-comparison-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureComparisonCardComponent {}


